import { render, staticRenderFns } from "./m-await-paiban-store.vue?vue&type=template&id=e43b477c&scoped=true&"
import script from "./m-await-paiban-store.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-await-paiban-store.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-await-paiban-store.vue?vue&type=style&index=0&id=e43b477c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43b477c",
  null
  
)

export default component.exports